import { AxiosCall } from "../../../common/services/AxiosService";

// Define the structure for the upload and delete functions
interface UploadFileProps {
  fileData: any;
  path: string;
  microserviceURL: string;
  personId: number | null;
}

interface DeleteFileProps {
  filePath: string;
  fileId: number;
  microserviceURL: string;
}

const getFormattedTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Month is 0-based
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}${month}${day}_${hour}${minute}`;
};

const timeStampValue = getFormattedTimestamp();
// Upload a file
export const uploadFile = async ({
  fileData,
  path,
  microserviceURL,
  personId,
}: UploadFileProps): Promise<any> => {

  try {
    const formData = new FormData();
    fileData.forEach((fileItem: any, index: number) => {
      const originalName = fileItem.mediaName;
      const nameWithoutExt = originalName.replace(/\.[^/.]+$/, ""); // removes the last extension
      formData.append(`attachments[${index}][file]`, fileItem.mediaFile);
      formData.append(`attachments[${index}][caption]`, fileItem.mediaCaption);
      formData.append(`attachments[${index}][type]`, fileItem.mediaType);
      formData.append(
        `attachments[${index}][name]`,
        `${personId?.toString() ?? ""}_${nameWithoutExt.replace(/\s+/g, "_")}_${timeStampValue}`
      );
    });

    const response = await AxiosCall.fileUploadService(
      formData,
      path,
      microserviceURL
    );

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Upload failed with status:", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error uploading files:", error);
    throw error;
  }
};

// Delete a file
export const deleteFile = async ({
  filePath,
  fileId,
  microserviceURL,
}: DeleteFileProps): Promise<any> => {
  try {
    const response = await AxiosCall.fileDeleteService(
      filePath,
      fileId,
      microserviceURL
    );

    // If deletion is successful, return the response
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Deletion failed with status:", response.status);
    }
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};
